/* eslint-disable default-case */
import { LinearProgress } from '@material-ui/core'
import deburr from 'lodash.deburr'
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'

import Context from '../../context'
import { getCouponsListByUnit } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

import CouponsListItem from './CouponsListItem'
import useStyles from './styles'

function CouponsList() {
  const classes = useStyles()
  const { user, setUser, setAboutCurrentPage } = useContext(Context)
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState('1')
  const [query, setQuery] = useState('')
  const [couponsList, setCouponsList] = useState([])
  const [unsortedList, setUnsortedList] = useState([])

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setUser(getLoggedUser())
    setAboutCurrentPage({
      title: 'Validador',
      tabs: [
        { title: 'Validador', pathname: '/uservalidate' },
        { title: 'Pagamentos', pathname: '/paymentslist' },
        { title: 'Cupons', pathname: '/couponslist' }
      ]
    })
  }, [])

  useEffect(() => {
    if (user?.partnerId) {
      setLoading(true)
      getCouponsListByUnit(user.partnerId).then(res => {
        setCouponsList(res.sort((a, b) => new Date(a.updatedAt) > new Date(b.updatedAt)))
        setUnsortedList(res)
        setLoading(false)
      })
    }
  }, [user])

  const errorMessage = ''

  const handleSortByChange = value => {
    setSortBy(value)
    switch (value) {
      case '1':
        setCouponsList(unsortedList.sort((a, b) => new Date(a.updatedAt) > new Date(b.updatedAt)))
        break

      case '2':
        setCouponsList(
          unsortedList.sort((a, b) => deburr(a.client?.name).localeCompare(deburr(b.client?.name)))
        )
        break
    }
  }

  const handleQueryChange = value => {
    setQuery(value)
    if (value.trim().length === 0) return

    setCouponsList(
      unsortedList.filter(
        item =>
          deburr(item.client?.name).toLowerCase().includes(deburr(value).toLowerCase()) ||
          deburr(item.code).toLowerCase().includes(deburr(value).toLowerCase())
      )
    )
  }

  return (
    <div className={classes.outerContainer}>
      <div className={classes.content}>
        <div className={classes.row}>
          <div className={classes.filters}>
            <div />
            <div>
              Ordenar por:{' '}
              <select
                className={classes.sorting}
                value={sortBy}
                onChange={e => handleSortByChange(e.target.value)}
              >
                <option value="1">Data do Resgate</option>
                <option value="2">Nome do Cliente</option>
              </select>
            </div>
          </div>
          <input
            className={classes.search}
            value={query}
            onChange={e => handleQueryChange(e.target.value)}
            placeholder="Buscar..."
          />
        </div>
        <table className={classes.table}>
          <thead>
            <tr>
              <th scope="col">Assinante</th>
              <th scope="col">Código</th>
              <th scope="col">Data</th>
            </tr>
          </thead>
          <tbody>
            {couponsList?.map(item => {
              return <CouponsListItem key={item.id} item={item} />
            })}
          </tbody>
        </table>
        {couponsList?.length === 0 && errorMessage === '' && !loading && (
          <div className="alert alert-info text-center m-4">
            Nenhum cupom encontrado para este estabelecimento
          </div>
        )}
        {errorMessage}
        {loading && <LinearProgress style={{ marginTop: 30 }} />}
      </div>
    </div>
  )
}

export default CouponsList
